export const categories = [
  'all',
  'cultural',
  'mountains',
  'mammals',
  'flowers',
  'birds',
  'trees',
  'butterflies and moths',
  'reptiles and amphibians',
  'insects',
  'others vegetation',
  'landforms',
  'others',
];

export const dayCardOrder = [
  'lodgings',
  'flights',
  'mountains',
  'attractions',
  'places',
  'sidetrips',
  'sightings',
];



// WEBPACK FOOTER //
// ./src/constants/trekDayConstants.js